import { useStyles } from "./styles";
import { StatusActiveGeneralEnum } from "@/main/services/enum/StatusActiveGeneralEnum";
import { getOptionsStatusActiveGeneral } from "@/main/services/data/data";

interface Props {
	status: StatusActiveGeneralEnum;
}

export default function StatusActiveGeneralComponent(props: Props) {
	const classes = useStyles();
	const statusComplete = getOptionsStatusActiveGeneral().find((item) => item.key === props.status);

	const renderColor = () => {
		switch (props.status) {
			case StatusActiveGeneralEnum.Active:
				return "#00cc66";
			case StatusActiveGeneralEnum.Inactive:
				return "#949494";
			default:
				return "#949494";
		}
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={statusComplete?.value}
			style={{ backgroundColor: renderColor() }}
		>
			<span className={classes.spanContainer}>{statusComplete?.value}</span>
		</div>
	);
}
